import { render, staticRenderFns } from "./CoursesSubsectionAdmin.vue?vue&type=template&id=15ef94e4&scoped=true"
import script from "./CoursesSubsectionAdmin.vue?vue&type=script&lang=js"
export * from "./CoursesSubsectionAdmin.vue?vue&type=script&lang=js"
import style0 from "./CoursesSubsectionAdmin.vue?vue&type=style&index=0&id=15ef94e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ef94e4",
  null
  
)

export default component.exports